

//const HOST = 'http://localhost:8092';
//const HOST = 'https://t4-sports-backend.herokuapp.com';

//aws
//const HOST = 'http://t4-backend-prod.us-east-1.elasticbeanstalk.com';

//aws com https:
const HOST = 'https://t4-sports-backend.herokuapp.com';

export default {
    HOST : HOST
};
